<div class="table--column" :restrict-row-click="restrictRowClick"><slot></slot></div>